import { formatUnits, parseUnits } from "@ethersproject/units";
import { Trans } from "@lingui/macro";
import { formatAmount } from "pages/Event/utils/formatAmount";
import { roundBn } from "pages/Event/utils/roundBn";
import React from "react";

type Props = React.ComponentProps<"input"> & {
  amount?: string;
  onChangeAmount?: (amount: string) => void;
  balance: string | undefined;
  decimals: number;
};

const FromInput = ({ amount, onChangeAmount, balance, decimals, ...restProps }: Props) => {
  const max = React.useMemo(() => {
    if (!balance) {
      return;
    }
    return formatAmount(formatUnits(roundBn(parseUnits(balance, decimals), decimals), decimals), {
      thousandSeparated: false,
      mantissa: 4,
    });
  }, [balance, decimals]);

  const setMax = () => max && onChangeAmount?.(max);
  const isMax = React.useMemo(() => {
    return max === amount;
  }, [max, amount]);

  return (
    <div className="flex flex-col items-stretch gap-2 px-6 py-4 border rounded-sm bg-background-3">
      <div className="flex justify-between gap-2 text-inactive text-[1.2rem] leading-[1.5]">
        <p>
          <Trans>Pay: ${formatAmount(amount || "0", { trimMantissa: false })}</Trans>
        </p>

        <p>
          <Trans>Balance: ${formatAmount(balance || "0", { mantissa: 4, trimMantissa: false })}</Trans>
        </p>
      </div>

      <div className="flex items-center gap-2">
        <input
          type="number"
          min="0"
          placeholder="0.0"
          className="text-[1.8rem] leading-[1.5] placeholder:text-inactive w-full disabled:text-inactive"
          {...restProps}
          value={amount}
          onChange={(e) => onChangeAmount?.(e.target.value)}
        />

        {!!balance && !isMax && (
          <button
            className="h-[1.8rem] bg-main hover:bg-main-hover active:bg-main-active rounded-full py-0 px-[0.8rem] cursor-pointer text-[1rem] items-center"
            onClick={setMax}
            type="button"
          >
            <Trans>Max</Trans>
          </button>
        )}

        <p className="text-[1.2rem] leading-[2.4rem]">USDT</p>
      </div>
    </div>
  );
};

export default React.memo(FromInput);
